/* One delivery-country offer at a time. Shopify checkout remains authoritative. */
(function () {
  'use strict';
  if (window.BionoboShipping) return;
  var eu = new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' '));
  function valid(value) { return /^[A-Z]{2}$/.test(value || '') ? value : ''; }
  function threshold(country, config) {
    if (config.currency !== 'EUR' || !valid(country) || config.supportedCountries.indexOf(country) < 0) return null;
    return eu.has(country) ? config.euThreshold : config.internationalThreshold;
  }
  function country(response, selected) {
    return valid(selected) || valid(response && response.detected_values && response.detected_values.country && response.detected_values.country.handle);
  }
  function progress(cents, goal) {
    cents = Math.max(0, Number(cents) || 0);
    return { remaining: Math.max(0, goal - cents), percent: Math.min(100, Math.max(0, Math.floor(cents * 100 / goal))) };
  }
  var api = window.BionoboShipping = { threshold: threshold, country: country, progress: progress };
  var configNode = document.querySelector('[data-bn-shipping-config]');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  // The country selected in Shopify's localization form is also the checkout context.
  var currentCountry = valid(config.currentCountry);
  var chosen = '';
  try { chosen = valid(sessionStorage.getItem('bn-shipping-country')); } catch (_) { /* Optional country preference. */ }
  if (currentCountry && chosen && chosen !== currentCountry) {
    chosen = '';
    try { sessionStorage.removeItem('bn-shipping-country'); } catch (_) { /* The current Shopify country still wins. */ }
  }
  var resolved = currentCountry || chosen;
  function money(cents) {
    return new Intl.NumberFormat(config.language === 'es' ? 'es-ES' : 'en-IE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function render() {
    var goal = threshold(resolved, config);
    document.querySelectorAll('[data-bn-shipping-message]').forEach(function (node) {
      text(node, goal === null ? node.getAttribute('data-shipping-fallback') : node.getAttribute('data-shipping-template').replace('__AMOUNT__', money(goal)));
    });
    document.querySelectorAll('[data-bn-shipping-progress]').forEach(function (node) {
      var track = node.querySelector('[data-bn-shipping-track]');
      var labels = node.querySelector('[data-bn-shipping-labels]');
      if (goal === null) {
        if (track) track.hidden = true;
        if (labels) labels.hidden = true;
        text(node.querySelector('[data-bn-shipping-copy]'), node.getAttribute('data-shipping-fallback'));
        return;
      }
      var cents = Math.max(0, Number(node.getAttribute('data-shipping-total')) || 0);
      var state = progress(cents, goal);
      text(node.querySelector('[data-bn-shipping-copy]'), state.remaining ? node.getAttribute('data-shipping-remaining').replace('__AMOUNT__', money(state.remaining)) : node.getAttribute('data-shipping-qualified'));
      if (track) {
        track.hidden = false;
        track.setAttribute('aria-valuenow', String(state.percent));
        var fill = track.querySelector('.bnc-track-fill');
        if (fill) fill.style.width = state.percent + '%';
      }
      if (labels) labels.hidden = false;
      text(node.querySelector('[data-bn-shipping-current]'), money(cents));
      text(node.querySelector('[data-bn-shipping-goal]'), money(goal));
    });
  }
  api.refresh = render;
  api.getCountry = function () { return resolved; };
  document.addEventListener('change', function (event) {
    if (!event.target || event.target.name !== 'country_code') return;
    var selection = valid(event.target.value);
    if (!selection) return;
    resolved = chosen = selection;
    try { sessionStorage.setItem('bn-shipping-country', chosen); } catch (_) { /* Selection still works without storage. */ }
    render();
  }, true);
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    Promise.resolve().then(function () { pending = false; render(); });
  }).observe(document.body, { childList: true, subtree: true });
  render();
  if (resolved) return;
  var controller = typeof AbortController === 'function' ? new AbortController() : null;
  var timer = controller ? setTimeout(function () { controller.abort(); }, 3500) : null;
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
    .then(function (response) { if (!response.ok) throw new Error('Country unavailable'); return response.json(); })
    .then(function (response) { resolved = country(response, chosen); render(); })
    .catch(function () { /* Keep neutral checkout copy instead of guessing a visitor's country. */ })
    .finally(function () { if (timer) clearTimeout(timer); });
})();
